import React from "react"
import "./src/css/index.global.css"
import { ConsentManager } from "./src/components/ConsentManager"

export const wrapRootElement = ({ element }) => (
  <ConsentManager>{element}</ConsentManager>
)
